import { usePlatformContext } from './use-context';

const FULL_ACCESS_ROLES = new Set(['owner', 'superadmin']);

/**
 * Permisos granulares del usuario en el tenant activo (desde /me/context).
 * owner/superadmin pasan todo; '*' = comodin. El backend igual enforce (403);
 * esto es solo UX (ocultar acciones que el usuario no puede ejecutar).
 */
export function usePermissions() {
  const { data } = usePlatformContext();
  const role = data?.activeTenant.role ?? '';
  const permissions = data?.permissions ?? [];
  const can = (permission: string): boolean =>
    FULL_ACCESS_ROLES.has(role) || permissions.includes('*') || permissions.includes(permission);
  return { can, role, permissions };
}
